import {useDropzone} from 'react-dropzone';
import '../../style/FileUpload.less';
import {useTranslation} from 'react-i18next';
import React, {useEffect, useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

function FileUpload({isValid = false, showFilePreview = false, allowedFileTypes, maxSizeInMB, onFileDrop, fieldMessage, onDelete}) {
    const [t] = useTranslation();
    const [previewFiles, setPreviewFiles] = useState([]);

    useEffect(() => () => {
        // Make sure to revoke the data uris to avoid memory leaks
        previewFiles.forEach(file => URL.revokeObjectURL(file.preview));
    }, [previewFiles]);

    const onDrop = (acceptedFiles) => {
        setPreviewFiles(acceptedFiles.map(file => {
                return {
                    ...file,
                    preview: URL.createObjectURL(file)
                };
            })
        );
        onFileDrop(acceptedFiles);
    };

    const {getRootProps, getInputProps, fileRejections} = useDropzone({
        onDrop,
        noClick: false,
        noKeyboard: true,
        accept: allowedFileTypes,
        maxSize: maxSizeInMB * 1000000
    });

    function prepareFileErrorCode(errorCode) {
        return errorCode !== null ? errorCode.toUpperCase().replaceAll('-', '_') : '';
    }

    let className = 'file-upload';
    let errorMessage = null;
    if (!isValid) {
        errorMessage = t('Validation.REQUIRED');
        className += ' border-danger';
        className += ' is-invalid';
    }

    const dragNDropMessage = <p>{fieldMessage ? fieldMessage : t('FileUpload.DRAG_DROP_CUSTOM')}</p>;

    return (
        <>
            {showFilePreview ?
                previewFiles.map(file => {
                    return (
                        <div key={file.path} {...getRootProps({className: className + ' uploaded'})}>
                            <div className="text-center">
                                <p className='mr-3' id='text-file-path'>{file.path}</p>
                                <button
                                    className="btn btn-transparent-primary btn-icon"
                                    onClick={() =>
                                    {onDelete(undefined)}}
                                >
                                    <FontAwesomeIcon icon="times" className=""/>
                                </button>
                            </div>
                        </div>
                    )
                })
                :
                <div {...getRootProps({className: className})}>
                    <input {...getInputProps()}/>
                    <div className="text-center">
                        {dragNDropMessage}
                        <button className="btn btn-transparent-primary">{t('FileUpload.CHOOSE_FILE')}</button>
                        {maxSizeInMB &&
                        <>
                            <h4>{t('FileUpload.MAX_FILE_SIZE')}:</h4>
                            {maxSizeInMB} MB
                        </>
                        }
                        {
                            fileRejections.map(({errors}) => (
                                errors.map(e => (
                                    <div className="alert-danger" key={e.code}>{t(`Error.${prepareFileErrorCode(e.code)}`)}</div>
                                ))
                            ))}
                        {
                            errorMessage &&
                            <div className="text-danger">
                                {errorMessage}
                            </div>
                        }
                    </div>
                </div>
            }
        </>
    );
}

export default FileUpload;
